<!-- MasterBook・Bookのキービューの背景画像 -->
<template>
  <div class="main-image" :style="backgroundImageFromApi(url)" />
</template>

<script>
export default {
  name: "MbImageDisp",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.main-image {
  position: relative;
  background-color: #f0f0f0;
  height: 260px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
